import {
    ReportTemplatesView,
    ReportTemplatesViewColumn,
} from "@common/types/views/reportTemplatesView";
import { ViewDensity, ViewType } from "@common/types/views/views";

export const defaultReportTemplatesView: ReportTemplatesView = {
    type: ViewType.REPORT_TEMPLATES,
    columns: [
        { id: ReportTemplatesViewColumn.NAME, options: { pin: "left" } },
        { id: ReportTemplatesViewColumn.DESCRIPTION },
        { id: ReportTemplatesViewColumn.ENTITIES },
        {
            id: ReportTemplatesViewColumn.ACTIONS,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
        density: ViewDensity.MD,
    },
};
